import { render, staticRenderFns } from "./ContainerSavedMeals.vue?vue&type=template&id=b56658fa&scoped=true"
import script from "./ContainerSavedMeals.vue?vue&type=script&lang=js"
export * from "./ContainerSavedMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56658fa",
  null
  
)

export default component.exports